import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { AnimatePresence, motion } from "framer-motion"
import { FiChevronRight } from "react-icons/fi"
import { BsFacebook, BsInstagram, BsTwitter, BsYoutube } from "react-icons/bs"

const motionLinks = {
  initial: { y: 20, opacity: 0 },
  open: {
    y: 0,
    opacity: 1,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
    },
  },
  closed: {
    y: 0,
    opacity: 0,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
    },
  },
}

const Footer = ({ footer, site, social }) => {
  return (
    <footer className="text-orange-500 bg-orange-100 lg:grid lg:grid-cols-5">
      <aside className="hidden lg:relative lg:col-span-2 lg:block">
        <GatsbyImage
          image={footer.siteInfoImage.asset.gatsbyImageData}
          alt={footer.siteInfoImage.asset.altText}
          className="object-cover absolute inset-0"
        />
      </aside>

      <div className="px-4 py-16 sm:px-6 lg:px-8 lg:col-span-3">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
          <div>
            {/* <p className="font-medium text-2xl sm:text-3xl">Get social with us</p> */}

            <p className="font-medium text-xl sm:text-2xl mb-4">
              {footer.siteInfoTitle}
            </p>
            <div className="flex space-x-3">
              {footer.social.map((link, index) => {
                let iconPart
                if (link.icon === "Facebook") {
                  iconPart = <BsFacebook className="w-4 h-4" fill="black" />
                }
                if (link.icon === "Instagram") {
                  iconPart = <BsInstagram className="w-4 h-4" fill="black" />
                }
                if (link.icon === "Twitter") {
                  iconPart = <BsTwitter className="w-4 h-4" fill="black" />
                }
                if (link.icon === "Youtube") {
                  iconPart = <BsYoutube className="w-4 h-4" fill="black" />
                }

                return <Link to={link.url} key={index}>{iconPart}</Link>
              })}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <p className="font-medium">Explore</p>

              <nav className="flex flex-col mt-4 space-y-2 text-sm text-black">
                {footer.primaryMenu.items.map((link, index, arr) => {
                  const isDropdown = !!link.dropdownItems

                  if (isDropdown) {
                    return (
                      <motion.div variants={motionLinks} key={link.page.slug.current + "-" + index}>
                        {/* <p>{link.title} +</p> */}
                        <Link
                          to={link.page.slug.current}
                          className="flex gap-2 items-center"
                        >
                          {link.title}
                        </Link>
                        <div className="header__secondary absolute top-[80px] left-0 right-0  bg-white p-4 text-md z-10">
                          <nav className="header__secondary-nav flex flex-col gap-2">
                            {link.dropdownItems.map(dropdownItem => (
                              <motion.div variants={motionLinks} key={dropdownItem.page.slug.current + "-" + index}>
                                <Link to={dropdownItem.page.slug.current}>
                                  {dropdownItem.title}
                                </Link>
                              </motion.div>
                            ))}
                          </nav>
                        </div>
                      </motion.div>
                    )
                  }

                  if (link._type === "navPage") {
                    return (
                      <motion.div variants={motionLinks} key={link.page.slug.current + "-" + index}>
                        <Link
                          to={link.page.slug.current}
                          className="flex gap-2 items-center"
                        >
                          {link.title}
                          {index === arr.length - 1 ? "" : ""}
                        </Link>
                      </motion.div>
                    )
                  }
                })}
              </nav>
            </div>

            <div>
              <p className="font-medium">Support</p>

              <nav className="flex flex-col mt-4 space-y-2 text-sm text-black">
                {footer.secondaryMenu.items.map((link, index, arr) => {
                  const isDropdown = !!link.dropdownItems

                  if (isDropdown) {
                    return (
                      <motion.div variants={motionLinks} key={link.page.slug.current + "-" + index}>
                        {/* <p>{link.title} +</p> */}
                        <Link
                          to={link.page.slug.current}
                          className="flex gap-2 items-center"
                        >
                          {link.title}
                        </Link>
                        <div className="header__secondary absolute top-[80px] left-0 right-0  bg-white p-4 text-md z-10">
                          <nav className="header__secondary-nav flex flex-col gap-2">
                            {link.dropdownItems.map(dropdownItem => (
                              <motion.div variants={motionLinks}>
                                <Link to={dropdownItem.page.slug.current}>
                                  {dropdownItem.title}
                                </Link>
                              </motion.div>
                            ))}
                          </nav>
                        </div>
                      </motion.div>
                    )
                  }

                  if (link._type === "navPage") {
                    return (
                      <motion.div variants={motionLinks} key={link.page.slug.current + "-" + index}>
                        <Link
                          to={link.page.slug.current}
                          className="flex gap-2 items-center"
                        >
                          {link.title}
                          {index === arr.length - 1 ? "" : ""}
                        </Link>
                      </motion.div>
                    )
                  }
                })}
              </nav>
            </div>
          </div>
        </div>

        <div className="pt-12 mt-12 border-t border-orange-900">
          <div className="text-sm text-black sm:items-center sm:justify-between sm:flex">
            <div className="flex space-x-3">
              <Link className="hover:opacity-75" to="/privacy-policy">
                {" "}
                Privacy Policy{" "}
              </Link>
              <Link className="hover:opacity-75" to="/terms-conditions">
                {" "}
                Terms & Conditions{" "}
              </Link>
            </div>

            <p className="mt-4 sm:mt-0">
              ® {new Date().getFullYear()} Fetch Park
            </p>
          </div>
        </div>
      </div>
    </footer>

    // <footer className="bg-primary text-orange-50">
    //   <div className="p-6 lg:p-12 grid lg:grid-cols-4">
    //     <Link to="/">
    //       <GatsbyImage
    //         image={site.logo.asset.gatsbyImageData}
    //         alt={site.siteTitle}
    //         objectFit="contain"
    //         className="h-[100px] w-[150px]"
    //       />
    //     </Link>

    //     <nav>
    //       <h3 className="font-bold mb-1">{footer.primaryMenuTitle}</h3>
    //       {footer.primaryMenu.items.map((link, index, arr) => {
    //         const isDropdown = !!link.dropdownItems

    //         if (isDropdown) {
    //           return (
    //             <motion.div variants={motionLinks}>
    //               {/* <p>{link.title} +</p> */}
    //               <Link
    //                 to={link.page.slug.current}
    //                 className="flex gap-2 items-center"
    //               >
    //                 {link.title}
    //               </Link>
    //               <div className="header__secondary absolute top-[80px] left-0 right-0  bg-white p-4 text-md z-10">
    //                 <nav className="header__secondary-nav flex flex-col gap-2">
    //                   {link.dropdownItems.map(dropdownItem => (
    //                     <motion.div variants={motionLinks}>
    //                       <Link
    //                         to={dropdownItem.page.slug.current}
    //                       >
    //                         {dropdownItem.title}
    //                       </Link>
    //                     </motion.div>
    //                   ))}
    //                 </nav>
    //               </div>
    //             </motion.div>
    //           )
    //         }

    //         if (link._type === "navPage") {
    //           return (
    //             <motion.div variants={motionLinks}>
    //               <Link
    //                 to={link.page.slug.current}
    //                 className="flex gap-2 items-center"
    //               >
    //                 {link.title}
    //                 {index === arr.length - 1 ? "" : ""}
    //               </Link>
    //             </motion.div>
    //           )
    //         }
    //       })}
    //     </nav>

    //     <nav>
    //       <h3 className="font-bold mb-1">{footer.secondaryMenuTitle}</h3>
    //       {footer.secondaryMenu.items.map((link, index, arr) => {
    //         const isDropdown = !!link.dropdownItems

    //         if (isDropdown) {
    //           return (
    //             <motion.div variants={motionLinks}>
    //               {/* <p>{link.title} +</p> */}
    //               <Link
    //                 to={link.page.slug.current
    //                 }
    //                 className="flex gap-2 items-center"
    //               >
    //                 {link.title}
    //               </Link>

    //             </motion.div>
    //           )
    //         }

    //         if (link._type === "navPage") {
    //           return (
    //             <motion.div variants={motionLinks}>
    //               <Link
    //                 to={link.page.slug.current}
    //                 className="flex gap-2 items-center"
    //               >
    //                 {link.title}
    //                 {index === arr.length - 1 ? "" : ""}
    //               </Link>
    //             </motion.div>
    //           )
    //         }
    //       })}
    //     </nav>

    //     <nav>
    //       <h3 className="font-bold mb-1">{footer.socialMenuTitle}</h3>
    //       <div className="flex gap-3">
    //         {footer.social.map((link, index) => {
    //           let iconPart
    //           if (link.icon === "Facebook") {
    //             iconPart = <BsFacebook className="w-6 h-6" />
    //           }
    //           if (link.icon === "Instagram") {
    //             iconPart = <BsInstagram className="w-6 h-6" />
    //           }
    //           if (link.icon === "Twitter") {
    //             iconPart = <BsTwitter className="w-6 h-6" />
    //           }
    //           if (link.icon === "Youtube") {
    //             iconPart = <BsYoutube className="w-6 h-6" />
    //           }

    //           return <Link to={link.url}>{iconPart}</Link>
    //         })}
    //       </div>
    //     </nav>
    //   </div>
    // </footer>
  )
}

export default Footer
